export default __webpack_public_path__ + "static/media/diba-lapijazah.c4fca85e.png";